import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/user"

export const List = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}
export const Add = async (values) => {
    return await axiosInstance(options).post(`${path}/add`, values);
}
export const Edit = async (values) => {
    return await axiosInstance(options).put(`${path}/edit`, values);
}
export const Delete = async (values) => {
    return await axiosInstance(options).delete(`${path}/delete?o_id=${values[0]}`, values)
}
export const changepassword = async (values) => {
    return await axiosInstance(options).patch(`${path}/change-password`, values);
}
export const Details = async (id) => {
    return await axiosInstance(options).get(`${path}/details?o_id=${id}`);
}
export const Status = async (values) => {
    return await axiosInstance(options).patch(`${path}/change-status`, values)
}
export const GetAllCenters = async () => {
    return await axiosInstance(options).get(`${path}/get-all-centers`);
}
export const GetAllCentersWithDoctor = async () => {
    return await axiosInstance(options).get(`${path}/get-all-centers-with-doctor`);
}

// testimonials
export const AddTestimonial = async (values) => {
    return await axiosInstance(options).post(`${path}/testimonial/add`, values);
}
export const EditTestimonial = async (values) => {
    return await axiosInstance(options).put(`${path}/testimonial/edit`, values);
}
export const DeleteTestimonial = async (id) => {
    return await axiosInstance(options).delete(`${path}/testimonial/delete?o_id=${id}`);
}
export const DetailsTestimonial = async (id) => {
    return await axiosInstance(options).get(`${path}/testimonial/details?o_id=${id}`);
}
export const ListTestimonial = async (values) => {
    return await axiosInstance(options).post(`${path}/testimonial/list`, values);
}   
export const StatusTestimonial = async (values) => {
    return await axiosInstance(options).patch(`${path}/testimonial/change-status`, values)
}

// educational videos
export const AddEducationalVideo = async (values) => {
    return await axiosInstance(options).post(`${path}/educational-video/add`, values);
}
export const EditEducationalVideo = async (values) => {
    return await axiosInstance(options).put(`${path}/educational-video/edit`, values);
}
export const DeleteEducationalVideo = async (id) => {
    return await axiosInstance(options).delete(`${path}/educational-video/delete?o_id=${id}`);
}
export const DetailsEducationalVideo = async (id) => {
    return await axiosInstance(options).get(`${path}/educational-video/details?o_id=${id}`);
}
export const ListEducationalVideo = async (values) => {
    return await axiosInstance(options).post(`${path}/educational-video/list`, values);
}   
export const StatusEducationalVideo = async (values) => {
    return await axiosInstance(options).patch(`${path}/educational-video/change-status`, values)
}

// services
export const AddCenterService = async (values) => {
    return await axiosInstance(options).post(`${path}/service/add`, values);
}
export const EditCenterService = async (values) => {
    return await axiosInstance(options).put(`${path}/service/edit`, values);
}
export const DeleteCenterService = async (id) => {
    return await axiosInstance(options).delete(`${path}/service/delete?o_id=${id}`);
}
export const DetailsCenterService = async (id) => {
    return await axiosInstance(options).get(`${path}/service/details?o_id=${id}`);
}
export const ListCenterService = async (values) => {
    return await axiosInstance(options).post(`${path}/service/list`, values);
}   
export const StatusCenterService = async (values) => {
    return await axiosInstance(options).patch(`${path}/service/change-status`, values)
}

// specilization

export const ListCenterSpecilization = async (values) => {
    return await axiosInstance(options).post(`${path}/specialization/list`, values);
}

export const AddCenterSpecilization = async (values) => {
    return await axiosInstance(options).post(`${path}/specialization/add`, values);
}

export const EditCenterSpecilization = async (values) => {
    return await axiosInstance(options).put(`${path}/specialization/edit`, values);
}

export const DeleteCenterSpecilization = async (values) => {
    return await axiosInstance(options).delete(`${path}/specialization/delete?o_id=${values[0]}`)
}

export const DetailsCenterSpecilization = async (id) => {
    return await axiosInstance(options).get(`${path}/specialization/details?o_id=${id}`);
}

export const StatusCenterSpecilization = async (values) => {
    return await axiosInstance(options).patch(`${path}/specialization/change-status`, values)
}